/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ResendCodeDto } from '../../models/resend-code-dto';
import { ResendCodeResponseDto } from '../../models/resend-code-response-dto';

export interface ResendCode$Params {
  body: ResendCodeDto;
}

export function resendCode(
  http: HttpClient,
  rootUrl: string,
  params: ResendCode$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ResendCodeResponseDto>> {
  const rb = new RequestBuilder(rootUrl, resendCode.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResendCodeResponseDto>;
      }),
    );
}

resendCode.PATH = '/auth/signup/resend-code';
